import React, { Component } from 'react';
import creditTexts from '../../data/credits.json';

const propTypes = {
    language: React.PropTypes.string.isRequired,
};

const defaultProps = {
};

const contextTypes = {
};

function createMarkup(markup) {
    return { __html: markup };
}

class CreditsPage extends Component {

    constructor(props) {
        super(props);
        this.credits = null;
    }

    renderCreditBlock(name, block) {
        const { language } = this.props;
        const title = block[`title_${language}`];
        const description = block[`description_${language}`];
        const image = block[`image_${language}`];

        return (
            <div className="top" key={name}>
                <h4 className="title">{title}</h4>
                <p className="description" dangerouslySetInnerHTML={createMarkup(description)} />
                { image ? (
                    <a href="http://www.hec.ca/" target="_blank" rel="noopener noreferrer">
                        <img className="image" src={image} alt={name} />
                    </a>
                ) : null }
                { block.items.map(item => (
                    <div className="credit-item">
                        <h4 className="subtitle">{item[`title_${language}`]}</h4>
                        { item.items.map(creditName => (
                            <p dangerouslySetInnerHTML={createMarkup(creditName)} />
                        ))}
                    </div>
                )) }
            </div>
        );
    }

    render() {
        // const { language } = this.props;
        const style = {
            maxWidth: 460,
            margin: '0 auto',
        };

        // const backLabel = language === 'fr' ? 'Fermer' : 'Close';
        // const backUrl = '/';
        // const backStyle = {
        //     display: 'inline-block',
        //     marginBottom: 20,
        // };

        return (
            <div className="credits" ref={(el) => { this.credits = el; }} style={style}>
                { this.renderCreditBlock('creation', creditTexts.creation) }
                { this.renderCreditBlock('onf', creditTexts.onf) }
                { this.renderCreditBlock('thanks', creditTexts.thanks) }
            </div>
        );
    }
}

// <a className="close-button" href={backUrl} style={backStyle} />

CreditsPage.propTypes = propTypes;
CreditsPage.defaultProps = defaultProps;
CreditsPage.contextTypes = contextTypes;

module.exports = CreditsPage;



// WEBPACK FOOTER //
// ./js/components/partials/CreditsPage.jsx